import mixins from '@synergycms_core/less/mixins';

export default {
    footer:{
        display: 'flex',
        flexWrap: 'wrap',
        textAlign: 'center',
        justifyContent: 'space-between',
        position: 'relative',
        zIndex: '1',
        marginTop: 'auto',
        width: '100%',
        background: '#fff',
        '@media (min-width:801px)':{
            flexWrap: 'nowrap',
            borderTop:'1px solid #D9D9D9',
            height: '50px',
            zIndex:'10',
            display: 'flex',
            alignItems: 'center',
            width: '100%',
            '&:lang(ar)': {
                direction: 'rtl',
            }
        }
    },
    footerContent:{
        order: '1',
        width: '100%',
        '@media (min-width:801px)':{
            width: 'auto',
            order: '2',
            height:'50px',
            flex: '1 1 auto',
            minWidth: '0',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            padding: '0 16px',

            '&:lang(ar)': {
                height: 'auto',
                order: '2',
            }
        }
    },
    footerContentTitleButton:{
        //height:'50px',
        width:'100%',
        textAlign:'left',
        padding:'12px 20px',
        textTransform:'uppercase',
        position:'relative',
        borderBottom:'1px solid #d9d9d9',
        fontFamily:'Roboto',
        fontWeight:'500',
        fontStyle:'Medium',
        fontSize:'15px',
        color:'#666666',
    },
    footerContentTitleIcon:{
        position:'absolute',
        top:'50%',
        right:'20px',
        marginTop:'-9px',
        fontSize: '16px',
    },
    footerInfo:{
        display:'flex',
        flexDirection:'column',
        gap: '20px',
        borderBottom: '1px solid #d9d9d9',
        padding: '20px 0',
        '@media (min-width:801px)':{
            borderBottom: 'none',
            flexDirection: 'row',
            justifyContent:'center',
            gap: '15px',
            padding: '0',
            display: 'flex',
            flexWrap: 'wrap',
            alignItems: 'center',
        },
        '@media (min-width:801px) and (max-width:1080px)': {
            columnGap: '10px',
            rowGap: '0px',
        },
        '@media (min-width:1080px)':{
            gap: '20px',
        }
    },
    footerItemGroup: {
        display: 'flex',
        alignItems: 'center',
        gap: '20px',
        rowGap: '0px',
        '@media (min-width:801px)':{
            gap: '15px',
        },
        '@media (min-width:801px) and (max-width:1080px)': {
            columnGap: '10px',
            rowGap: '0px',
        },
        '@media (min-width:1080px)':{
            gap: '20px',
        }
    },
    linkSeparator: {
        position: 'relative',
        content: '',
        width: '3px',
        height: '3px',
        borderRadius: '50%',
        background: '#666666',
        bottom: 'calc(50% - 2px)',
    },
    footerLink:{
        position:'relative',
        display:'block',
        marginBottom:'10px',
        textDecoration:'none',
        cursor:'pointer',
        textAlign:'left',
        '@media (min-width:801px)':{
            '&:after':{
                bottom:0,
                content: "'·'",
                height:'100%',
                position:'absolute',
                right:0,
                top:0,
                width:'2px'
            },
            display:'inline-block',
            paddingRight:'10px',
            marginBottom:0,
            marginRight:'10px',
            verticalAlign:'middle',
            margin:'0 auto 10px',
        },
        '&:last-of-type':{
            marginBottom:0,
            '@media (min-width:801px)':{
                '&:after':{
                    content:'none',
                },
                paddingRight:0,
                marginRight:0
            }
        },
        '&:lang(ar)': {
            textAlign: 'right',
        }
    },
    footerLinkText:{
        color:'#707070',
        font: '15px Roboto, sans-serif',
    },
    seeLinksEnter: {
        transition: 'max-height 0ms ease-out',
        maxHeight: '0'
    },
    seeLinksEnterActive: {
        maxHeight: '400px',
        transition: 'max-height 400ms ease-out',
        overflow: 'hidden',
    },
    seeLinksLeave: {
        maxHeight: '400px',
        transition: 'max-height 0 ease-out',
        overflow: 'hidden'
    },
    seeLinksLeaveActive: {
        maxHeight: 0,
        transition: 'max-height  400ms ease-out'
    },
    logoElement:{
        paddingLeft: '15px',
        width: '102px',
        height: '32px',
        fill: '#000',
        '@media (min-width:801px)':{
            width: '107px',
            height: '33px',
        },
        '@media (min-width:1080px)':{
            marginTop:'6px',
            paddingLeft: '20px',
        }
    },
    safeBuy:{
        color:'#707070',
        font: "13px / 16.41px 'Open Sans', sans-serif",
        '@media (min-width:1081px)': {
            fontSize: '14px',
        },
    },
    safeBuyBreak:{
        whiteSpace: 'normal',
        overflowWrap: 'anywhere',
        wordBreak: 'break-word',
    },
    safeBuySmall:{
        color:'#707070',
        font: "12px / 16.41px 'Open Sans', sans-serif",
    },
    footerLeftLogo:{
        order: '2',
        verticalAlign:'middle',
        textAlign:'left',
        padding: '10px 0',
        '&:lang(ar)': {
            order: '3',
            borderRight: 'none',
            borderLeft: '1px solid #999',
        },
        '@media (min-width:801px)':{
            order: '1',
            padding: '0',
            flex: '0 0 250px',
            width: '250px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-start',
        }
    },
    footerRightLogo:{
        display: 'flex',
        flexDirection:'column',
        justifyContent:'center',
        order: '3',
        textAlign: 'right',
        borderRight: 'none',
        //minWidth: '170px',
        boxSizing: 'border-box',
        paddingRight: '15px',
        paddingLeft: '10px',

        minWidth: '0',
        flex: '1',
        '@media (min-width:801px)':{
            order: '3',
            height: '100%',
            flex: '0 0 250px',
            width: '250px',
            alignItems: 'flex-end',
            paddingLeft: '0',
            '&:lang(ar)': {
                order: '1',
                borderLeft: 'none',
            }
        },
        '@media (min-width:1080px)':{
            paddingRight:'20px',
        }
    }
}